import { Association } from '@/components/bulkUpload/Association';
import { StepButtons } from '@/components/multistep/Questionnaire';
import { useRegions } from '@/services/api/hooks/region';
import { useCSV, useMap, useResult } from '@/services/csv/useCSVService';
import { Maps } from '../helpers/enum';
import { useMismatchedRegions } from '../helpers/getMismatched';
import { Result } from './UploadFinanceModelStep';

export const ReviewFinanceModelRegionStep = () => {
  const result = useResult<Result>();
  if (!result) throw Error('No result');
  const [regions] = useRegions();
  const uniqueAndNewRegions = useMismatchedRegions(result, regions);
  const addMapAssociation = useCSV(state => state.addMapAssociation);
  const regionsMap = useMap(Maps.Regions);

  const canGoNext = uniqueAndNewRegions.reduce((acc, m) => {
    return acc && regionsMap?.[m] !== undefined;
  }, true);

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-3 gap-5">
        {uniqueAndNewRegions.map(m => (
          <Association
            key={m}
            incoming={m}
            options={regions.map(region => {
              return {
                id: region.id,
                name: region.code
              };
            })}
            onAssociate={(incoming, choice) => {
              addMapAssociation(Maps.Regions, incoming, choice.id);
            }}
            mapping={regionsMap?.[m]}
          />
        ))}
      </div>
      <StepButtons canGoNext={canGoNext} />
    </div>
  );
};
